import { provideHttpClient, withInterceptorsFromDi, withXhr, withInterceptors } from '@angular/common/http';
import { cookielessBearerHostInterceptor } from '@galaxy/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { provideErrorTracking } from '@vendasta/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { StorefrontModule, StorefrontService } from '@vendasta/storefront';
import { provideProtoTransport } from '@vendasta/protos';
import { environment } from '../globals';
import { AppComponent } from './app.component';
import { ImageService } from './core/image.service';
import { GalaxyDefaultProviderOverrides } from '@vendasta/galaxy/provider-default-overrides';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    RouterModule.forRoot([], {}),
    TranslateModule,
    LexiconModule.forRoot(),
    BrowserModule,
    StorefrontModule.forRoot(environment),
    ProductAnalyticsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideErrorTracking(),
    provideProtoTransport(),
    ...GalaxyDefaultProviderOverrides,
    ImageService,
    {
      provide: 'PARTNER_ID',
      useFactory: (storefrontService: StorefrontService) => {
        return storefrontService.partnerId$;
      },
      deps: [StorefrontService],
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([cookielessBearerHostInterceptor])),
  ],
})
export class AppModule {}
